import { ReactNode, useState, SyntheticEvent, useEffect, useContext, useRef } from 'react';
import { collection, query, getDocs } from "firebase/firestore";
import Carousel from 'react-material-ui-carousel';

import { DbGet } from 'config/firebase';
import { DataContext } from 'providers/data';

import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Typography, AccordionSummary, AccordionDetails, Collapse } from '@mui/material';

import Menu from 'components/views/Menu';
import NavTitle from 'components/views/NavTitle';
import ModalClube from 'components/views/ModalClube';
import InputSearch from 'components/views/form/InputSearch';
import FormEmail from 'components/views/ServiceFaq/FormEmail';
import { Banner, ContentBodyPage, ContentNewsPage } from 'components/views/ContainersPage';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcChatOn } from 'assets/icons/ic-chat-on.svg';
import { ReactComponent as IcAdicional } from 'assets/icons/products/ic-adicional.svg';
import { ReactComponent as IcRastreador } from 'assets/icons/products/ic-rastreador.svg';
import { ReactComponent as IcNotFoundSearch } from 'assets/icons/ic-not-found-search.svg';
import { ReactComponent as IcIturanSeguro } from 'assets/icons/products/ic-ituran-seguro.svg';
import { ReactComponent as IcRastreadorPlus } from 'assets/icons/products/ic-rastreador-plus.svg';
import { ReactComponent as IcIturanSeguroMoto } from 'assets/icons/products/ic-ituran-seguro-moto.svg';
import { ReactComponent as IcIturanSeguroLight } from 'assets/icons/products/ic-ituran-seguro-light.svg';

import BannerClub from 'assets/images/banners/desk/banner-club-desk.png';
import BannerAppDesk from 'assets/images/banners/desk/banner-app-desk.png';
import BannerUpgradeRfDesk from 'assets/images/banners/desk/banner-upgrade-rf-desk.png';
import BannerDadosAtualizadosDesk from 'assets/images/banners/desk/banner-dados-atualizados-desk.png';

import { BoxBanner, TabCustom, BoxCustom, AccordionCustom, BoxSvg, LinkExtermal, BannerContent } from './styles';

const dataTab = [
    {
        text: 'Ituran com Seguro',
        value: '8',
        icon: <IcIturanSeguro />
    },
    {
        text: 'Ituran com Seguro Moto',
        value: '10',
        icon: <IcIturanSeguroMoto />
    },
    {
        text: 'Ituran Connect',
        value: '9',
        icon: <IcRastreador />
    },
    {
        text: 'Ituran Connect Plus',
        value: '11',
        icon: <IcRastreadorPlus />
    },
    {
        text: 'Serviços Adicionais',
        value: '12',
        icon: <IcAdicional />
    },
    {
        text: 'Ituran com Seguro Light',
        value: '13',
        icon: <IcIturanSeguroLight />
    }
];

type ParamsAccordion = {
    title: string;
    children: ReactNode;
}

type ParamsQuestions = {
    title: string;
    id: number;
    description: string;
    typeQuestionId: number;
}

type ParamsTypeQuestions = {
    id: number;
    name: string;
}

type ParamsTopQuestionsIds = {
    question: string;
    id: number;
}

const Accordion = ({ title, children }: ParamsAccordion) => {
    return (
        <AccordionCustom>
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon color='secondary' fontSize='large' />}>
                <Typography fontSize='.9375rem' lineHeight='18px' fontWeight={600}>
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{
                width: '100%',
                display: 'flex',
                padding: {
                    xs: '1.5625rem 0 0',
                    md: '1.1875rem 3rem 1.1875rem 0'
                },
                justifyContent: 'center',
            }}>
                {children}
            </AccordionDetails>
        </AccordionCustom>
    );
}

const ServiceFaq = () => {
    const [value, setValue] = useState('8');
    const divRef = useRef<HTMLDivElement>(null);
    const [showTab, setShowTab] = useState(true);
    const [showService, setShowService] = useState(false);
    const [showModalClube, setShowModalClube] = useState(false);

    const { selectedCar, dataObterDadosCorretorPorPedido, blockClick, handlePostObterDadosCorretorPorPedido } = useContext(DataContext);

    const [dataFaqQuestions, setDataFaqQuestions] = useState<Array<ParamsQuestions>>();
    const [dataFaqQuestionsFilter, setDataFaqQuestionsFilter] = useState<Array<ParamsQuestions>>();
    const [dataFaqTypeQuestions, setDataFaqTypeQuestions] = useState<Array<ParamsTypeQuestions>>();

    const getFaq = async () => {
        let data: { questions: Array<ParamsQuestions>; typeQuestions: Array<ParamsTypeQuestions>, topQuestionsIds: Array<ParamsTopQuestionsIds> } = { questions: [], typeQuestions: [], topQuestionsIds: [] };

        const products = query(collection(DbGet, "faq"));
        const querySnapshot = await getDocs(products);

        querySnapshot.forEach((doc) => {
            // @ts-ignore
            data = doc.data();
        });

        Array.isArray(data?.questions) && setDataFaqQuestions(data?.questions);
        Array.isArray(data?.typeQuestions) && setDataFaqTypeQuestions(data?.typeQuestions);
    }

    useEffect(() => {
        if (!dataFaqQuestions || !dataFaqTypeQuestions) {
            getFaq();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataFaqQuestions, dataFaqTypeQuestions]);

    useEffect(() => {
        if (selectedCar && !dataObterDadosCorretorPorPedido && [1783625].indexOf(selectedCar?.CD_PESSOA_PARCEIRO) < 0) {
            handlePostObterDadosCorretorPorPedido({ NR_PLATAFORMA: selectedCar.NR_PLATAFORMA });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    const handleSearchAnswer = (e: string) => {
        if (dataFaqQuestions) {
            setShowTab(false);

            const aux = dataFaqQuestions.filter(({ title, description }) => title.toLowerCase().includes(e.toLocaleLowerCase()) || description.toLowerCase().includes(e.toLocaleLowerCase()));

            setDataFaqQuestionsFilter(aux);
            if (aux?.length === 0) {
                const boxMain = document?.getElementById('box-main');

                setTimeout(() => {
                    if (boxMain && divRef.current) {
                        boxMain.scrollTop = divRef.current.offsetTop - 100;
                    }
                }, 600);
            }
        }
    }

    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Menu titlePage='Atendimento'>
            <ContentBodyPage>
                <Box sx={{ width: '100%', textAlign: 'center', padding: { xs: '2.875rem 10px', md: '2.875rem 8%' }, backgroundColor: '#EFF2F5', marginBottom: '1.875rem' }}>
                    <Typography sx={{ fontSize: { xs: '1.125rem', md: '1.875rem' }, color: 'primary.light', fontWeight: 700 }}>
                        Como podemos te ajudar?
                    </Typography>
                    <InputSearch handleValue={(e) => handleSearchAnswer(e)} showTab={(e) => setShowTab(e)} />
                </Box>
                <Collapse in={showTab}>
                    <NavTitle title='Escolha um assunto' />
                </Collapse>
                <TabContext value={value}>
                    <Collapse in={showTab}>
                        <BoxCustom sx={{ display: { xs: 'none', md: 'block' } }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                {dataTab.map(({ text, value, icon }, index) =>
                                    index < 3 &&
                                    <TabCustom label={text} value={value} key={index} icon={icon} />
                                )}
                            </TabList>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                {dataTab.map(({ text, value, icon }, index) =>
                                    index >= 3 &&
                                    <TabCustom label={text} value={value} key={index} icon={icon} />
                                )}
                            </TabList>
                        </BoxCustom>
                        <BoxCustom sx={{ display: { xs: 'block', md: 'none' } }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                {dataTab.map(({ text, value, icon }, index) =>
                                    <TabCustom label={text} value={value} key={index} icon={icon} />
                                )}
                            </TabList>
                        </BoxCustom>
                    </Collapse>
                    {dataFaqQuestionsFilter?.length === 0 && !showTab &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={divRef}>
                            <IcNotFoundSearch />
                            <Typography sx={{ paddingTop: '.5rem', fontSize: '1rem', fontWeight: 700, lineHeight: '1.2rem', textAlign: 'center' }}>
                                Desculpe, desta vez não <br />
                                conseguimos te ajudar por aqui!
                            </Typography>
                        </Box>
                    }

                    {dataFaqQuestions && dataFaqQuestions?.length > 0 &&
                        <>
                            {showTab &&
                                <Typography sx={{ fontSize: '1.125rem', color: 'primary.light', fontWeight: 700, paddingTop: '2.125rem' }}>
                                    Perguntas mais frequentes:
                                </Typography>
                            }
                            {dataTab.map(({ value }, index) =>
                                <TabPanel value={value} key={index} sx={{ padding: '.8rem 0 0' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1.75rem' }}>
                                        {showTab ?
                                            dataFaqQuestions?.map(({ title, description, typeQuestionId }, index) =>
                                                parseFloat(value) === typeQuestionId &&
                                                <Accordion title={title} key={index}>
                                                    <Typography sx={{
                                                        fontSize: '.75rem',
                                                        color: 'grey.600',
                                                        lineHeight: '15px',
                                                        width: '100%',
                                                        'a': {
                                                            color: 'primary.main'
                                                        }
                                                    }}
                                                        dangerouslySetInnerHTML={{ __html: description }}></Typography>
                                                </Accordion>
                                            )
                                            :
                                            dataFaqQuestionsFilter?.map(({ title, description, typeQuestionId }, index) =>
                                                <Accordion title={title} key={index}>
                                                    <Typography sx={{
                                                        fontSize: '.75rem',
                                                        color: 'grey.600',
                                                        lineHeight: '15px',
                                                        width: '100%',
                                                        'a': {
                                                            color: 'primary.main'
                                                        }
                                                    }}
                                                        dangerouslySetInnerHTML={{ __html: description }}></Typography>
                                                </Accordion>
                                            )}
                                    </Box>
                                </TabPanel>
                            )}
                        </>
                    }
                </TabContext>
                <Collapse in={!showTab}>
                    <Box sx={{ width: '100%', marginTop: '3.125rem', backgroundColor: '#EFF2F5', padding: '.9rem 0 0' }}>
                        <Box sx={{ display: 'flex', paddingBottom: '.8rem', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                            <Typography sx={{ fontSize: '.875rem', fontWeight: 700 }}>
                                Ainda precisa de ajuda?
                            </Typography>
                        </Box>
                        <Box>
                            <FormEmail />
                            <Box sx={{ width: '100%', backgroundColor: '#EFF2F5', padding: '.9rem 0 0' }}>
                                <Box sx={{ display: 'flex', paddingBottom: '.8rem', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', position: 'relative' }} onClick={() => setShowService(!showService)}>
                                    <Typography sx={{ fontSize: '.875rem', fontWeight: 700 }}>
                                        Outros canais de atendimento
                                    </Typography>
                                    <BoxSvg className={showService ? 'show' : 'hide'}>
                                        <ExpandMoreIcon fontSize='medium' />
                                    </BoxSvg>
                                </Box>
                                <Collapse in={showService}>
                                    <Box sx={{ padding: '0rem 2.5rem 2rem', maxWidth: '37.5rem', margin: '0 auto' }}>
                                        <Typography fontSize='.875rem' fontWeight={600} lineHeight='1.3' textAlign='center' paddingBottom='.5rem'>
                                            Atendimento de Segunda à Sexta das 08h as 18h <br /> e aos Sábados das 8h às 14h
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'center', md: 'flex-end' }, marginBottom: '.4rem' }}>
                                            <Box>
                                                <Typography fontSize='.9375rem' fontWeight={600} textTransform='uppercase'>
                                                    SAC São Paulo
                                                </Typography>
                                                <LinkExtermal href="tel:551136169000">
                                                    (011) 3616-9000
                                                    <LocalPhoneOutlinedIcon />
                                                </LinkExtermal>
                                            </Box>
                                            <Box>
                                                <LinkExtermal href="https://ituranservicos.zendesk.com/hc/pt-br" target='blank' className='chat'>
                                                    SAC / CHAT
                                                    <IcChatOn />
                                                </LinkExtermal>
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'center', md: 'flex-end' } }}>
                                            <Box>
                                                <Typography fontSize='.9375rem' fontWeight={600} textTransform='uppercase'>
                                                    SAC demais localidades
                                                </Typography>
                                                <LinkExtermal href="tel:08007742000">
                                                    0800 774 2000
                                                    <LocalPhoneOutlinedIcon />
                                                </LinkExtermal>
                                            </Box>
                                            <Box>
                                                <LinkExtermal href="https://api.whatsapp.com/send/?phone=551136169000" target='blank' className='chat'>
                                                    SAC / WHATSAPP
                                                    <IcChatOn />
                                                </LinkExtermal>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Collapse>
                            </Box>
                        </Box>
                    </Box>
                </Collapse>
            </ContentBodyPage>

            <ContentNewsPage>
                <BoxBanner>
                    <NavTitle title='Contatos úteis' />
                    <Box marginTop='1.25rem'>
                        <Box>
                            <Typography fontSize='.9375rem' fontWeight={600} textTransform='uppercase' color='secondary.main'>
                                TELEVENDAS
                            </Typography>
                            <LinkExtermal href="tel:08000105566">
                                0800 010 5566
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                        </Box>
                        <Box>
                            <Typography fontSize='.9375rem' fontWeight={600} textTransform='uppercase' color='secondary.main'>
                                ROUBO E FURTO
                            </Typography>
                            <LinkExtermal href="tel:08000153600">
                                0800 015 3600
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                        </Box>
                        <Box>
                            <Typography fontSize='.9375rem' fontWeight={600} textTransform='uppercase' color='secondary.main'>
                                SAC SP
                            </Typography>
                            <LinkExtermal href="tel:1136169000">
                                (011) 3616-9000
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                        </Box>
                        <Box>
                            <Typography fontSize='.9375rem' fontWeight={600} textTransform='uppercase' color='secondary.main'>
                                SAC Demais Localidades
                            </Typography>
                            <LinkExtermal href="tel:08007742000">
                                0800 774 2000
                                <LocalPhoneOutlinedIcon />
                            </LinkExtermal>
                        </Box>
                        {dataObterDadosCorretorPorPedido && dataObterDadosCorretorPorPedido?.Celular && selectedCar && [0, 1783625].indexOf(selectedCar?.CD_PESSOA_PARCEIRO) < 0 &&
                            <Box>
                                <Typography fontSize='.9375rem' fontWeight={600} textTransform='uppercase' color='secondary.main'>
                                    {dataObterDadosCorretorPorPedido.Nome}
                                </Typography>
                                <LinkExtermal href={`tel:${dataObterDadosCorretorPorPedido.Celular}`}>
                                    {dataObterDadosCorretorPorPedido.Celular}
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                            </Box>
                        }
                    </Box>
                    {selectedCar?.COMODATO ?
                        [1079756].indexOf(selectedCar?.CODIGO_SEGURADORA) >= 0 ?
                            <Carousel sx={{ width: '100%', minHeight: '27.25rem', 'button': { display: 'none' } }}>
                                <Banner bannerImg={BannerClub} link='https://www.clubedevantagensituran.com.br/' linkExternal />
                                <Banner bannerImg={BannerDadosAtualizadosDesk} link='/meus-dados' />
                            </Carousel>
                            :
                            <Banner bannerImg={BannerDadosAtualizadosDesk} link='/meus-dados' />
                        :
                        <Carousel sx={{ width: '100%', minHeight: '27.25rem', 'button': { display: 'none' } }}>
                            <BannerContent>
                                <img src={BannerAppDesk} alt="banner" />
                                {/* eslint-disable jsx-a11y/anchor-has-content */}
                                <a href="https://apps.apple.com/br/app/ituran-digital/id1486608545" className='apple' target='blank' />
                                <a href="https://play.google.com/store/search?q=ituran&c=apps" className='android' target='blank' />
                            </BannerContent>
                            <Banner bannerImg={BannerUpgradeRfDesk} link={!blockClick ? '/central-de-trocas' : ''} />
                        </Carousel>
                    }
                </BoxBanner>
            </ContentNewsPage>

            <ModalClube openModal={showModalClube} handleClickClosed={() => setShowModalClube(false)} />
        </Menu>
    );
}

export default ServiceFaq;